// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/icons/tablet.css
// module id = 856
// module chunks = 0